 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		14: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		14: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"commons","2":"128821699d391ac07b26155deb174f2a76c26ff7","3":"1c23093a14a00f0d0dc1b8abc8c85cfa7d71268f","4":"04e84cb90ebc377d0bba051d899bba6d181c1670","5":"a6af2c3a708135f4ca096d87f1e14adc04f00877","6":"2b64aa18bd737cd44dc363612c9ae910560c8cae","7":"f56733337838cb123d37edae9dc8aacc51d16631","8":"6dbbc67c24e86c3bf030d6a20e8c9bb226418a5f","9":"75d2b24adbbb4f2e79aa5f6f2d3f4700f209e8bd","10":"components-AlgoliaFilters","11":"e25ead2d3994eef88c6a57243d65012b117e349c","12":"ed55a733247ed04807222feac645aed3173f63c2","13":"framework","16":"component---gatsby-theme-nurofen-src-templates-article-listing-page-article-listing-page-tsx","17":"component---gatsby-theme-nurofen-src-templates-article-page-article-page-tsx","18":"component---gatsby-theme-nurofen-src-templates-contact-us-page-contact-us-page-tsx","19":"component---gatsby-theme-nurofen-src-templates-error-404-page-error-404-page-tsx","20":"component---gatsby-theme-nurofen-src-templates-home-page-home-page-tsx","21":"component---gatsby-theme-nurofen-src-templates-lds-page-lds-page-tsx","22":"component---gatsby-theme-nurofen-src-templates-product-list-page-product-list-page-tsx","23":"component---gatsby-theme-nurofen-src-templates-product-page-product-page-tsx","24":"component---gatsby-theme-nurofen-src-templates-promotion-campaign-page-promotion-campaign-page-tsx","25":"component---gatsby-theme-nurofen-src-templates-quiz-page-quiz-page-tsx","26":"component---gatsby-theme-nurofen-src-templates-quiz-result-page-quiz-result-page-tsx","27":"component---gatsby-theme-nurofen-src-templates-search-page-search-page-tsx","28":"component---gatsby-theme-nurofen-src-templates-sitemap-page-sitemap-page-tsx","29":"component---gatsby-theme-nurofen-src-templates-symptoms-page-symptoms-page-tsx","30":"component---gatsby-theme-nurofen-src-templates-where-to-buy-page-where-to-buy-page-tsx","31":"components-NewsletterPopups"}[chunkId]||chunkId) + "-" + {"0":"81852b6058b0ef837ba8","1":"0d0a2b799b36843d6989","2":"babc534bcd2313cf2b79","3":"c9d55d353b594b5e184d","4":"d26148f753e91d587f88","5":"0cfed8a8162fcf1ac3fe","6":"19ad987782e64a9d650c","7":"5d92b711de4d043afbb5","8":"308b74dd3a101956c70a","9":"9af8df73dd6d31e5d91a","10":"f481117638e40312624c","11":"857de951e6b04c6ccdc4","12":"4527638ec3310927c090","13":"0ab1a2dda4560fecee8f","16":"b713df855b0522a02f5c","17":"fde88fa5a57541c350ec","18":"5608421b39d72e1f2583","19":"cc9e3608c678e798d504","20":"d5db9774609c3fad3b4d","21":"18542efed8fc0af395f9","22":"29888efa8fa858dc16e1","23":"6f0c99f19e33fa778ebd","24":"cbd4bbc4492cb99211c1","25":"c877fecbbc78e85c8565","26":"f1e7baa455bb99b80524","27":"862a9d902b71104bef72","28":"e530565b4553ca308a89","29":"137badd86dbf9cf430db","30":"ea37db5cf3bc8c176d19","31":"702196fff3a7e4e4d915","33":"1c9e7165f882ad0f1e8d"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"commons","2":"128821699d391ac07b26155deb174f2a76c26ff7","3":"1c23093a14a00f0d0dc1b8abc8c85cfa7d71268f","4":"04e84cb90ebc377d0bba051d899bba6d181c1670","5":"a6af2c3a708135f4ca096d87f1e14adc04f00877","6":"2b64aa18bd737cd44dc363612c9ae910560c8cae","7":"f56733337838cb123d37edae9dc8aacc51d16631","8":"6dbbc67c24e86c3bf030d6a20e8c9bb226418a5f","9":"75d2b24adbbb4f2e79aa5f6f2d3f4700f209e8bd","10":"components-AlgoliaFilters","11":"e25ead2d3994eef88c6a57243d65012b117e349c","12":"ed55a733247ed04807222feac645aed3173f63c2","13":"framework","16":"component---gatsby-theme-nurofen-src-templates-article-listing-page-article-listing-page-tsx","17":"component---gatsby-theme-nurofen-src-templates-article-page-article-page-tsx","18":"component---gatsby-theme-nurofen-src-templates-contact-us-page-contact-us-page-tsx","19":"component---gatsby-theme-nurofen-src-templates-error-404-page-error-404-page-tsx","20":"component---gatsby-theme-nurofen-src-templates-home-page-home-page-tsx","21":"component---gatsby-theme-nurofen-src-templates-lds-page-lds-page-tsx","22":"component---gatsby-theme-nurofen-src-templates-product-list-page-product-list-page-tsx","23":"component---gatsby-theme-nurofen-src-templates-product-page-product-page-tsx","24":"component---gatsby-theme-nurofen-src-templates-promotion-campaign-page-promotion-campaign-page-tsx","25":"component---gatsby-theme-nurofen-src-templates-quiz-page-quiz-page-tsx","26":"component---gatsby-theme-nurofen-src-templates-quiz-result-page-quiz-result-page-tsx","27":"component---gatsby-theme-nurofen-src-templates-search-page-search-page-tsx","28":"component---gatsby-theme-nurofen-src-templates-sitemap-page-sitemap-page-tsx","29":"component---gatsby-theme-nurofen-src-templates-symptoms-page-symptoms-page-tsx","30":"component---gatsby-theme-nurofen-src-templates-where-to-buy-page-where-to-buy-page-tsx","31":"components-NewsletterPopups"}[chunkId]||chunkId) + "." + {"0":"06a41dd8a66fd7c6851b","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
